import { createSelector } from 'reselect';

const selectCalculatorPageDomain = () => (state) => state.get('calculatorPage') ? state.get('calculatorPage').toJS() : {};

export const makeSelectForm = () => createSelector(
  selectCalculatorPageDomain(),
  (substate) => substate.form,
);

